import PasswordIcon from "@mui/icons-material/Password";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import forget from "../../assets/ForgetPassword.svg";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


import { toast } from "react-toastify";
import axios from "axios";
import image from "../../assets/resetPassword.webp";
// import logo from "../../assets/clinical-visuals-logo-white.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import { useSearchParams } from "react-router-dom";
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const logo = VISUALIZE__URL + "Clinical_Visuals_Logo.webp";
const ResetPassword = () => {
  const { t } = useTranslation();
  const [username, setUsername] = useState("");
  const [newpassword, setNewpassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [passworderror, setPassworderror] = useState("");
  const [usernameerror, setUsernameerror] = useState("");
  const [confirmpassworderror, setConfirmPassworderror] = useState("");
  const [showPassword, setShowPassword] = useState<boolean>(false);


  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Get the token value

  const validatePassword = (password: string): string | null => {
    if (!password.trim()) {
      return "Password should not be empty.";
    }

    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasSpecialChar = /[^A-Za-z0-9]/.test(password); // Checks for at least one special character

    if (!(hasLowercase && hasUppercase && hasDigit && hasSpecialChar)) {
      return "Password must include at least 1 lowercase, 1 uppercase letter, 1 digit, and 1 special character.";
    }

    if (password.length < 8) {
      return "Password must be at least 8 characters long.";
    }

    return null; //  No errors
  };

  const handleSubmit = async () => {
    let hasError = false;

    //  Validate username
    if (!username.trim()) {
      setUsernameerror("Username should not be empty");
      hasError = true;
    }

    //  Validate password
    const passwordError = validatePassword(newpassword);
    if (passwordError) {
      setPassworderror(passwordError);
      hasError = true;
    } else {
      setPassworderror("");
      hasError = false;
    }

    //  Validate confirm password
    if (!confirmpassword.trim()) {
      setConfirmPassworderror("Confirm Password cannot be empty.");
      hasError = true;
    } else if (newpassword !== confirmpassword) {
      setConfirmPassworderror("Passwords do not match.");
      hasError = true;
    } else {
      setConfirmPassworderror("");
      hasError = false;
    }

    if (hasError) return; // Stop execution if there are errors

    //  Construct payload
    const payload = {
      token: token,
      userName: username.trim(),
      newPassword: newpassword.trim(),
      confirmPassword: confirmpassword.trim(),
    };


    try {
      const response = await axios.put(
        `${API_BASE_URL}auth/reset-password`,
        payload
      );

      //  Show success message
      toast.success(response.data.message);
      handleClose();
    } catch (error) {
      console.error("API Error:", error);

      //  Handle API errors properly
      if (axios.isAxiosError(error)) {
        toast.error(error.response?.data?.message || "An error occurred.");
      } else if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error("Something went wrong.");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleClose = () => {
    setNewpassword("");
    setConfirmpassword("");
    setPassworderror("");
    setConfirmPassworderror("");
  };

  return (
    <Grid container sx={{ height: "100vh", width: "100vw" }}>
      <Grid
        item
        xs={12}
        md={6}
        lg={7}
        xl={7}
        sx={{
          position: "relative",
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: { xs: "none", md: "block" },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.4)",
          }}
        />
        <Box
          component="img"
          src={logo}
          alt="Logo"
          sx={{
            position: "absolute",
            top: { xs: 30, sm: 40, md: 50 }, // Increased top space
            left: { xs: 30, sm: 50, md: 60 }, // Increased left space
            width: { xs: 100, sm: 120, md: 200 },
            height: "auto",
          }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        lg={5}
        xl={5}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.paper",
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", sm: "75%", md: "60%" },
            maxWidth: "600px",
            p: { xs: 3, sm: 4, md: 5 },
            textAlign: "center",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <img
              src={forget}
              alt="Forgot Password"
              style={{ width: "30%", maxWidth: "100px" }}
            />
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#0d6bca", mt: 2 }}
            >
              {t("reset_password")}
            </Typography>
          </Box>

          <Grid container spacing={2} mt={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder={t("username")}
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                error={!!usernameerror}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 2 },
                }}
              />

              {usernameerror && (
                <Box
                  sx={{
                    position: "relative",
                    mt: 1,
                    p: 1,
                    pl: 2,
                    // background: "rgba(185, 179, 179, 0.5)",
                    borderRadius: "8px",
                    textAlign: "left",
                    fontSize: "14px",
                    maxWidth: "80%",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: "-8px", // Adjust arrow position
                      top: "50%",
                      transform: "translateY(-50%)",
                      borderWidth: "6px",
                      borderStyle: "solid",
                      borderColor:
                        "transparent rgba(185, 179, 179, 0.5) transparent transparent",
                    },
                  }}
                >
                  {usernameerror}
                </Box>
              )}

              
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder={t("new_password")}
                variant="outlined"
                value={newpassword}
                onChange={(e) => setNewpassword(e.target.value)}
                error={!!passworderror}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PasswordIcon />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 2 },
                }}
              />

              {passworderror && (
                <Box
                  sx={{
                    position: "relative",
                    mt: 1,
                    p: 1,
                    pl: 2,
                    borderRadius: "8px",
                    textAlign: "left",
                    fontSize: "14px",
                    maxWidth: "80%",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: "-8px", // Adjust arrow position
                      top: "50%",
                      transform: "translateY(-50%)",
                      borderWidth: "6px",
                      borderStyle: "solid",
                      borderColor:
                        "transparent rgba(185, 179, 179, 0.5) transparent transparent",
                    },
                  }}
                >
                  {passworderror}
                </Box>
              )}

             
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder={t("confirm_new_password")}
                variant="outlined"
                type={showPassword ? "text" : "password"}
                value={confirmpassword}
                onChange={(e) => setConfirmpassword(e.target.value)}
                error={!!confirmpassworderror}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PasswordIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 2 },
                }}
              />
              {confirmpassworderror && (
                <Box
                  sx={{
                    position: "relative",
                    mt: 1,
                    p: 1,
                    pl: 2,
                    borderRadius: "8px",
                    textAlign: "left",
                    fontSize: "14px",
                    maxWidth: "80%",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: "-8px", // Adjust arrow position
                      top: "50%",
                      transform: "translateY(-50%)",
                      borderWidth: "6px",
                      borderStyle: "solid",
                      borderColor:
                        "transparent rgba(185, 179, 179, 0.5) transparent transparent",
                    },
                  }}
                >
                  {confirmpassworderror}
                </Box>
              )}

            </Grid>
          </Grid>

          <Box
            sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="submit"
              onClick={handleSubmit}
              sx={{
                mt: 2,
                height: "45px",
                width: "30%",
                justifyContent: "center",
                fontSize: "16px",
                borderRadius: "10px",
                textTransform: "none",
              }}
            >
              {t("continue")}
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
